/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  API_BASE_PATH: 'https://bot-tel-api-dev-cwfgbqfch6h7f4d3.westeurope-01.azurewebsites.net',
  MINI_SITE_BASE_PATH: 'https://cal-dev.ekoya.ai',
  version: '1.0.0-dev',
  SUPABASE_URL: 'https://tctrsbinpxlmibsxywwe.supabase.co',
  SUPABASE_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRjdHJzYmlucHhsbWlic3h5d3dlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI2ODI4MzMsImV4cCI6MjA1ODI1ODgzM30.vRJBnzFcje8myfvGfOx3qaSmjLTThaLsny4d1-d_GP8',
};
